import { useMutation } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

import { ItemAiChatError, itemAiChatErrorMessage } from './itemAiChatError';

interface SendItemAiChatMessage {
  declarationId: string;
  goodsShipmentItemId: string;
  sessionId: string;
  question: string;
}

export const useSendItemAiChatMessage = () =>
  useMutation({
    mutationFn: async ({ declarationId, goodsShipmentItemId, sessionId, question }: SendItemAiChatMessage) => {
      const result = await apiClient.itemAiChat.sendItemAiChatMessage.mutation({
        params: { declarationId, goodsShipmentItemId, sessionId },
        body: { question },
      });
      if (result.status !== 200) throw new ItemAiChatError(result.status);
      return result.body;
    },
    onError: (error) => {
      showErrorToast(error, itemAiChatErrorMessage(error));
    },
  });
